(function () {
  'use strict';

  /* Cantidad (+ / −) */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input[name="quantity"], input[name="updates[]"]');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    value += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    input.value = Math.max(min, value);
  });

  /* Galería de producto */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.getElementById('main-image');
    if (!main) return;
    main.src = thumb.getAttribute('data-full');
    main.alt = thumb.getAttribute('data-alt') || '';
    var all = document.querySelectorAll('[data-thumb]');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.toggle('is-active', all[i] === thumb);
    }
  });

  /* Variantes: actualiza precio y botón */
  var variantSelect = document.getElementById('variant-select');
  var variantsJson = document.getElementById('variants-json');
  if (variantSelect && variantsJson) {
    var variants = [];
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { variants = []; }
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    var currency = (priceEl && priceEl.getAttribute('data-currency')) || 'EUR';
    var lang = document.documentElement.lang || 'es';
    var fmt;
    try { fmt = new Intl.NumberFormat(lang, { style: 'currency', currency: currency }); } catch (e2) { fmt = null; }
    var money = function (cents) { return fmt ? fmt.format(cents / 100) : (cents / 100).toFixed(2); };

    variantSelect.addEventListener('change', function () {
      var id = parseInt(variantSelect.value, 10);
      var v = null;
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) { v = variants[i]; break; } }
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) addBtn.disabled = !v.available;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e3) { /* sin soporte de URL */ }
    });
  }

  /* Ordenar colección */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
